import React, { useContext } from 'react'
import cn from 'classnames'
import Image from 'react-graceful-image'
import { AudioContext } from 'rewact'
import * as Icon from '../Icons'
import TrackContext from '../../context/TrackContext'
import { useDelayedState } from '../../hooks'

import CURATED_SELECTION from '../filters/curatedSelection'

import styles from './home.module.css'

export default function TracksOfTheMonth({ curatedTab }) {
  const { playerTrack, setPlayerTrack } = useContext(TrackContext)
  const { isPaused, play, pause } = useContext(AudioContext)
  const [isReallyPaused] = useDelayedState(
    isPaused,
    process.env.NODE_ENV === 'production' ? 300 : 100
  )
  return (
    <ul className={styles.covers}>
      {CURATED_SELECTION[curatedTab].map(({ name, artist, image, slug }) => {
        const isActive = playerTrack.slug === slug
        const imgSrc = require(`../../images/${image}`)
        return (
          <li
            key={`${artist}_${name}`}
            className={styles.cover}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              if (isActive) {
                if (isPaused) {
                  play()
                } else {
                  pause()
                }
              } else {
                setPlayerTrack({
                  // id: `curated_${name}_${artist}`,
                  artist,
                  name,
                  slug,
                  image: imgSrc,
                })
                setTimeout(() => play(), 100)
              }
            }}
          >
            <div className={styles.coverBlurWrapper}>
              <div
                style={{ width: '100%', paddingBottom: '100%' }}
                aria-hidden
              />
              <Image
                src={imgSrc}
                width={150}
                height={150}
                alt={`${artist} Cover`}
                className={cn(styles.coverImgImg, styles.coverImgImgBlur)}
              />
            </div>
            <div
              className={cn(styles.coverImgContainer, {
                [styles.active]: isActive,
              })}
            >
              <div className={styles.coverImg}>
                <div
                  style={{ width: '100%', paddingBottom: '100%' }}
                  aria-hidden
                />
                <Image
                  src={imgSrc}
                  width={150}
                  height={150}
                  alt={`${artist} Cover`}
                  className={styles.coverImgImg}
                />
              </div>
              <span
                className={cn(styles.coverPlayButton, {
                  [styles.isPlay]: !isActive || isReallyPaused,
                })}
              >
                {isActive && !isReallyPaused ? <Icon.Pause /> : <Icon.Play />}
              </span>
            </div>
            <h5 className={styles.coverTitle}>{artist}</h5>
          </li>
        )
      })}
    </ul>
  )
}
